export var EMAIL_PLACEHOLDER = 'example@address.com';
export var EMAIL_ERROR_MESSAGE = 'Invalid Email';